import { useState } from "react";
import { Check, X } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage, titleCase } from "@/lib/api";
import { Input } from "@/components/common/Field";

const FIELDS = ["registration_no", "make", "model", "year", "fuel_type", "transmission", "vehicle_type", "status", "group", "ownership", "current_odometer_km", "vin", "engine_no", "color", "fastag_id", "location", "purchase_date", "notes",
  "insurance_expiry", "puc_expiry", "fitness_expiry", "tax_expiry", "permit_expiry", "warranty_expiry"];
const label = (k) => (k.endsWith("_expiry") ? `${titleCase(k.replace("_expiry", ""))} expiry` : titleCase(k));

export function ImportRowEditor({ row, onSaved, onCancel }) {
  const [d, setD] = useState({ ...row.data });
  const [busy, setBusy] = useState(false);
  const bad = new Set(row.errors.map((e) => e.split(" ")[0]));
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.patch(`/import/rows/${row.id}`, d); toast.success(data.errors.length ? `Saved — ${data.errors.length} issue(s) remain` : "Row fixed — ready to approve"); onSaved(); } catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <tr data-testid={`row-editor-${row.id}`}>
      <td colSpan={6} className="bg-muted/40 px-3 py-3">
        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3 lg:grid-cols-4">
          {FIELDS.filter((k) => k in d || bad.has(k) || ["registration_no", "make", "model"].includes(k)).map((k) => (
            <label key={k} className="text-xs">
              <span className={bad.has(k) ? "font-medium text-destructive" : "text-muted-foreground"}>{label(k)}</span>
              <Input data-testid={`row-field-${k}`} className="mt-0.5 h-9 text-sm" type={k.endsWith("_expiry") || k === "purchase_date" ? "date" : "text"} value={d[k] || ""} onChange={(e) => setD({ ...d, [k]: e.target.value })} error={bad.has(k)} />
            </label>
          ))}
        </div>
        {row.errors.length > 0 && <p className="mt-2 text-xs text-destructive">{row.errors.join("; ")}</p>}
        <div className="mt-3 flex justify-end gap-2">
          <button type="button" onClick={onCancel} data-testid="row-editor-cancel" className="flex h-9 items-center gap-1 rounded-full px-3 text-sm font-medium text-primary hover:bg-primary/10"><X className="h-4 w-4" />Cancel</button>
          <button type="button" onClick={save} disabled={busy} data-testid="row-editor-save" className="flex h-9 items-center gap-1 rounded-full bg-primary px-3 text-sm font-semibold text-primary-foreground hover:bg-[#0071e3] disabled:opacity-50"><Check className="h-4 w-4" />{busy ? "Saving…" : "Save & revalidate"}</button>
        </div>
      </td>
    </tr>
  );
}
